import { render, staticRenderFns } from "./ConsultaListaAtributoDocumentacao.vue?vue&type=template&id=eb3ca146&scoped=true&"
import script from "./ConsultaListaAtributoDocumentacao.vue?vue&type=script&lang=js&"
export * from "./ConsultaListaAtributoDocumentacao.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaListaAtributoDocumentacao.vue?vue&type=style&index=0&id=eb3ca146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3ca146",
  null
  
)

export default component.exports